<template>
    <div>
        <v-progress-circular
            v-if="loading"
            indeterminate
            size="24"
            width="3"
        ></v-progress-circular>
        <span v-else-if="value.pmsStatus">
            <v-icon :color="statusColor">
                {{ icons.device }}
            </v-icon>
            <v-icon :color="statusColor" small class="icon-suffix">{{
                iconSuffix
            }}</v-icon>
            {{ value.partnerDeviceStatus }} - {{ value.partnerDeviceUpTime }}
        </span>
        <span v-else>
            not configured
        </span>
    </div>
</template>
<script>
import statusColors from '@/shared/statusColors';
import { VIcon, VProgressCircular } from 'vuetify/lib';

export default {
    name: 'PmsStatus',
    components: {
        'v-icon': VIcon,
        'v-progress-circular': VProgressCircular
    },
    props: {
        value: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        iconSuffixMap() {
            return {
                Online: this.icons.check,
                Offline: this.icons.close
            };
        },
        statusColor() {
            const colorSet = this.$vuetify.theme.isDark
                ? statusColors.dark
                : statusColors.light;
            if (
                this.value &&
                this.value.partnerDeviceStatus &&
                colorSet[this.value.partnerDeviceStatus]
            ) {
                return colorSet[this.value.partnerDeviceStatus];
            } else {
                return colorSet.default;
            }
        },
        iconSuffix() {
            if (
                this.value &&
                this.iconSuffixMap[this.value.partnerDeviceStatus]
            ) {
                return this.iconSuffixMap[this.value.partnerDeviceStatus];
            }
            return this.icons.question;
        }
    }
};
</script>

<style lang="scss" scoped>
.status-icon {
    white-space: nowrap !important;
}
.icon-suffix {
    margin-left: -4px;
}
</style>
